<template>
    <div class="account-container">
        <!-- 검색 필터 -->
        <div class="account-filter-row">
            <input type="date" v-model="searchStart" class="account-filter-input" />
            ~
            <input type="date" v-model="searchEnd" class="account-filter-input" />
            <button class="btn search" @click="fetchLogs">조회</button>
            <button class="btn print" @click="handleRegister">등록</button>
        </div>

        <!-- 프로토콜 리스트 -->
        <table class="account-table auditlog-table">
            <thead>
            <tr>
                <th>no</th>
                <th>프로토콜 명</th>
                <th>전류</th>
                <th>시간</th>
                <th>파형</th>
                <th>사용여부</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in protocolList" :key="row.id || idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ row.description }}</td>
                <td>{{ row.current }}</td>
                <td>{{ row.time }}</td>
                <td>{{ row.waveform }}</td>
                <td :class="{ fail: row.status === 'N' }">
                    {{ row.status === 'Y' ? '사용' : '미사용' }}
                </td>
            </tr>
            </tbody>
        </table>

        <div class="account-pagination auditlog-pagination">&lt; 1 &gt;</div>

        <!-- 모달: 프로토콜 등록폼 -->
        <div v-if="showProtocolRegister" class="modal-overlay">
            <div class="modal" @click.stop>
                <h3>프로토콜 등록</h3>
                <form @submit.prevent="submitProtocol">
                    <div>
                        <label>적용 병원</label>
                        <select v-model="newProtocol.hospital_scope" required>
                            <option value="전체">전체</option>
                            <option value="병원1">병원1</option>
                            <option value="병원2">병원2</option>
                        </select>
                    </div>
                    <div>
                        <label>전류</label>
                        <input type="number" v-model="newProtocol.current" required />
                    </div>
                    <div>
                        <label>시간</label>
                        <input type="number" v-model="newProtocol.time" required />
                    </div>
                    <div>
                        <label>파형</label>
                        <select v-model="newProtocol.waveform" required>
                            <option value="Square">Square</option>
                            <option value="Sine">Sine</option>
                        </select>
                    </div>
                    <button type="submit">저장</button>
                    <button type="button" @click="showProtocolRegister = false">취소</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AuditLog',
    data() {
        return {
            searchStart: '',
            searchEnd: '',
            protocolList: [],
            showProtocolRegister: false,
            newProtocol: {
                hospital_scope: '전체',
                current: null,
                time: null,
                waveform: 'Square',
            },
        };
    },
    methods: {
        async fetchLogs() {
            try {
                const res = await axios.get(`/api/diagnosis/protocolList`);
                this.protocolList = res.data.list || res.data || [];
            } catch (err) {
                console.error('프로토콜 불러오기 실패', err);
            }
        },
        handleRegister() {
            this.showProtocolRegister = true;
        },
        async submitProtocol() {
            try {
                // 실제 API 주소와 메서드에 맞게 수정하세요
                await axios.post(`/api/diagnosis/protocolRegister`, this.newProtocol);
                alert('프로토콜이 등록되었습니다.');
                this.showProtocolRegister = false;
                this.fetchLogs(); // 등록 후 리스트 갱신
                // 초기화
                this.newProtocol = {
                    hospital_scope: '전체',
                    current: null,
                    time: null,
                    waveform: 'Square',
                };
            } catch (error) {
                alert('프로토콜 등록 실패');
                console.error(error);
            }
        },
    },
    mounted() {
        this.fetchLogs();
    },
};
</script>